import { registerEnumType } from 'type-graphql'

import { StatusToneEnum } from './StatusToneEnum'

export enum StatusEnum {
  Active = 'Active',
  InActive = 'InActive',
  Pending = 'Pending',
}

registerEnumType(StatusEnum, {
  name: 'StatusEnum',
  description: 'The basic status of entity',
})

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const Status = {
  Active: {
    value: StatusEnum.Active,
    description: 'The entity is active and available for use.',
    sort: 0,
    tone: StatusToneEnum.Active,
  },
  InActive: {
    value: StatusEnum.InActive,
    description: 'The entity is inactive and hidden from selections.',
    sort: 1,
    tone: StatusToneEnum.Inactive,
  },
  Pending: {
    value: StatusEnum.Pending,
    description: 'The entity is pending review or activation.',
    sort: 2,
    color: 'var(--status-custom-amber)',
  },
}
